import React from "react";
const SvgPinMap = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M12 3C8.126 3 5 6.109 5 9.945c0 2.277 1.355 4.717 2.962 6.793 1.578 2.038 3.33 3.636 4.038 4.251.707-.615 2.46-2.213 4.038-4.251C17.645 14.662 19 12.222 19 9.945 19 6.11 15.874 3 12 3zM4 9.945C4 5.55 7.58 2 12 2s8 3.55 8 7.945c0 2.626-1.536 5.293-3.171 7.405-1.65 2.13-3.476 3.79-4.193 4.411a.966.966 0 01-1.272 0c-.717-.622-2.542-2.28-4.193-4.411C5.536 15.238 4 12.571 4 9.945zm8-2.914c-1.653 0-3 1.351-3 3.026 0 1.675 1.347 3.027 3 3.027s3-1.352 3-3.027-1.347-3.026-3-3.026zm-4 3.026c0-2.22 1.787-4.026 4-4.026s4 1.806 4 4.026c0 2.22-1.787 4.027-4 4.027s-4-1.806-4-4.027z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPinMap;
